import { Button, Cell, Input, Layout, Loading, Toast } from 'auto-ui'
import { useEffect } from 'react'
import { useSetState } from 'react-use'
import { domianConfig } from '../../utils/config'
import http from '../../utils/http'
import './style.scss'

interface IState {
  loading: boolean
  errorMsg: string
  orderNo: string
  list: any
}

const PageIndex = () => {
  const [state, setState] = useSetState<IState>({
    loading: false,
    errorMsg: '',
    orderNo: '',
    list: [],
  })

  const onInputChange = (e: any) => {
    const value = e.target.value

    if (!value || !value.trim()) {
      return
    }

    setState({
      orderNo: value,
    })
  }

  const fetchOrderByOrderNo = async () => {
    try {
      if (!state.orderNo) {
        Toast('请输入订单号')
        return
      }

      Loading()
      const result: any = await http.request({
        url: '/order/orderList',
        method: 'POST',
        data: {
          orderId: state.orderNo,
        },
      })
      const { body = [] } = result

      if (!body || !Array.isArray(body) || body.length === 0) {
        Toast('没有查找到相关订单')
        return
      }

      setState({
        list: body,
      })
    } catch (error: any) {
      Toast(error.message || '')
    } finally {
      Loading.hide()
      setState({
        orderNo: '',
      })
    }
  }

  const fetchOrderList = async () => {
    try {
      setState({ loading: true })
      const result: any = await http.request({
        url: '/order/orderList',
        method: 'POST',
        data: {},
      })

      const { body = [] } = result

      setState({
        list: body || [],
      })
    } catch (error: any) {
      setState({
        errorMsg: error.message || '',
      })
    } finally {
      setState({
        loading: false,
      })
    }
  }

  const onEnterOrderDetail = (item: any) => {
    const { orderId, productType } = item
    const domain: any = domianConfig.get(productType)
    const { url } = domain

    window.location.href = url + '?orderNo=' + orderId
  }

  useEffect(() => {
    fetchOrderList()
  }, [])

  return (
    <Layout className="page-order" useBottomSafeArea={false}>
      <Layout.Body errorInfo={state.errorMsg} loading={state.loading}>
        <div className="search">
          <Input onChange={onInputChange} placeholder="请输入订单号" allowClear />
          <div className="btn">
            <Button mini type="danger" onClick={fetchOrderByOrderNo}>
              搜索
            </Button>
          </div>
        </div>

        {state.list.length > 0 ? (
          <Cell onClick={onEnterOrderDetail} className="list" arrow={true} dividerIndent="left">
            {state.list.map((item: any) => {
              const { emotionParam, bName, gName, marriageParam } = item.orderParams
              return (
                <Cell.Row
                  key={item.orderId}
                  className="row"
                  value={item}
                  addonAfter={
                    item.status === 2 ? (
                      <span className="blue">支付成功</span>
                    ) : (
                      <span className="red">未支付</span>
                    )
                  }
                >
                  {item.productType === 11 ? (
                    <div className="info">
                      <div className="title">{emotionParam?.name + '生辰测算'}</div>
                      <div className="orderNo">订单号：{item.orderId}</div>
                      <div className="time">测算时间：{item.orderTime}</div>
                    </div>
                  ) : item.productType === 10 ? (
                    <div className="info">
                      <div className="title">{bName + '与' + gName + '合婚'}</div>
                      <div className="orderNo">订单号：{item.orderId}</div>
                      <div className="time">配对时间：{item.orderTime}</div>
                    </div>
                  ) : item.productType === 6 ? (
                    <div className="info">
                      <div className="title">{bName + '与' + gName + '姓名配对'}</div>
                      <div className="orderNo">订单号：{item.orderId}</div>
                      <div className="time">配对时间：{item.orderTime}</div>
                    </div>
                  ) : item.productType === 9 ? (
                    <div className="info">
                      <div className="title">{marriageParam.name + '姻缘测试'}</div>
                      <div className="orderNo">订单号：{item.orderId}</div>
                      <div className="time">测试时间：{item.orderTime}</div>
                    </div>
                  ) : item.productType === 3 ? (
                    <div className="info">
                      <div className="title">MBTI性格测试</div>
                      <div className="orderNo">订单号：{item.orderId}</div>
                      <div className="time">测试时间：{item.orderTime}</div>
                    </div>
                  ) : item.productType === 2 ? (
                    <div className="info">
                      <div className="title">智商测试</div>
                      <div className="orderNo">订单号：{item.orderId}</div>
                      <div className="time">测试时间：{item.orderTime}</div>
                    </div>
                  ) : null}
                </Cell.Row>
              )
            })}
          </Cell>
        ) : (
          <div className="nodata">
            暂无订单数据
            <br />
            您可以直接输入订单号搜索
          </div>
        )}
      </Layout.Body>
    </Layout>
  )
}

export default PageIndex
